/**
 * Capitalize filter
 * @param value {string}
 * @returns {string}
 */

export  let capitalize = value => {

    if (!value) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1)

};



// WEBPACK FOOTER //
// capitalize.js